import {Pipe, PipeTransform} from '@angular/core';
import {Article} from "../../core/models/articles/articles.model";

@Pipe({
  name: 'shortDescription',
})
export class ShortDescriptionPipe implements PipeTransform {
  transform(article: Article): string {
    const shortDescription = $localize.locale === 'en' && (article.englishShortDescription || article.englishDescription)
      || article.shortDescription || article.description;

    if (!shortDescription) {
      return '';
    }

    if (shortDescription.length > 200) {
      return shortDescription.slice(0, 200) + '</p> <strong>...</strong>';
    }

    return shortDescription;
  }
}
